import { Component } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';

import { SwitchCasesTaskMerged } from '../../../../../services/dto/switch-cases';
import { SwitchCaseBaseComponent } from '../switch-case-base/switch-case-base.component';

@Component({
  selector: 'cam-switch-cases-task-merged',
  templateUrl: './switch-cases-task-merged.component.html',
  styleUrls: ['./switch-cases-task-merged.component.scss'],
  imports: [TranslatePipe],
})
export class SwitchCasesTaskMergedComponent extends SwitchCaseBaseComponent<SwitchCasesTaskMerged> {}
